import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../../utils/createApi";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";

export const getAndSaveSiteImages = async (
  siteCameras: any,
  setSrcImages: any,
  navigate: any
) => {
  const AxiosUI = createApi("");
  const retryFunction = () => {
    getAndSaveSiteImages(siteCameras, setSrcImages, navigate);
  };

  const setCameraPreview = (cameraObj: any, statusData: any) => {
    setSrcImages((previousState: any) => {
      const name = `${cameraObj.id}full`;
      const previewSrc = (
        statusData?.preview_url ||
        cameraObj.preview_url ||
        ""
      ).trim();
      return {
        ...previousState,
        [cameraObj.id]: (
          <TooltipPreviewImageWithRetry
            src={previewSrc}
            onRetry={() => {
              refreshSingleCameraPreview(cameraObj);
            }}
          />
        ),
        [name]: statusData,
      };
    });
  };

  const refreshSingleCameraPreview = (cameraObj: any) => {
    AxiosUI.get(`/camera/${cameraObj.id}/status/`).then(
      (response: AxiosResponse) => {
        setCameraPreview(cameraObj, response.data);
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      }
    );
  };

  siteCameras.results.forEach((obj: any) => {
    refreshSingleCameraPreview(obj);
  });
};

const TooltipPreviewImageWithRetry = ({
  src,
  onRetry,
}: {
  src: string;
  onRetry: () => void;
}) => {
  const [loadFailed, setLoadFailed] = React.useState(false);
  const [retryTriggered, setRetryTriggered] = React.useState(false);
  const normalizedSrc = (src || "").trim();

  React.useEffect(() => {
    setLoadFailed(false);
    setRetryTriggered(false);
  }, [normalizedSrc]);

  React.useEffect(() => {
    if ((!normalizedSrc || loadFailed) && !retryTriggered) {
      setRetryTriggered(true);
      onRetry();
    }
  }, [normalizedSrc, loadFailed, retryTriggered, onRetry]);

  if ((!normalizedSrc || loadFailed) && retryTriggered) {
    return (
      <div className="font-mulish text-[12px] text-gray-600 px-[8px] py-[6px]">
        Camera preview unavailable.
      </div>
    );
  }

  if (!normalizedSrc || loadFailed) {
    return (
      <div className="font-mulish text-[12px] text-gray-600 px-[8px] py-[6px]">
        Refreshing camera preview...
      </div>
    );
  }

  return (
    <img
      src={normalizedSrc}
      alt="site_image"
      onError={() => setLoadFailed(true)}
      style={{ maxWidth: "360px", maxHeight: "220px", display: "block" }}
    />
  );
};
